import React, { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { uploadFile, mediaUrl, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Progress } from "@/components/ui/progress";

export default function MediaInput({ value, onChange, accept = "image/*", label, testid = "media", video = false }) {
  const ref = useRef(null);
  const [progress, setProgress] = useState(null);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 100 * 1024 * 1024) { toast.error("El archivo supera 100MB"); return; }
    setProgress(0);
    try {
      const url = await uploadFile(f, setProgress);
      onChange(url);
      toast.success("Archivo subido");
    } catch (err) {
      toast.error(errMsg(err, "Error al subir el archivo"));
    } finally {
      setProgress(null);
      if (ref.current) ref.current.value = "";
    }
  };

  const isVideo = video && value && !/youtu/.test(value);
  return (
    <div className="space-y-2">
      {label && <label className="text-sm font-medium text-gray-700">{label}</label>}
      <div className="flex gap-2">
        <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={video ? "URL de video MP4 o enlace de YouTube" : "URL de la imagen"} data-testid={`${testid}-url-input`} />
        <button type="button" onClick={() => ref.current?.click()} disabled={progress !== null} data-testid={`${testid}-upload-btn`}
          className="shrink-0 h-10 px-3 rounded-md border border-gray-300 hover:border-[var(--brand)] hover:text-[var(--brand)] flex items-center gap-1.5 text-sm transition-colors disabled:opacity-50">
          {progress !== null ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}Subir
        </button>
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={onFile} />
      </div>
      {progress !== null && <div className="flex items-center gap-2"><Progress value={progress} className="h-2" /><span className="text-xs text-gray-500 w-10">{progress}%</span></div>}
      {value && (
        <div className="relative inline-block">
          {isVideo ? <video src={mediaUrl(value)} className="h-24 rounded-md" muted /> : /youtu/.test(value) ? <span className="text-xs text-gray-500">Video de YouTube configurado</span> :
            <img src={mediaUrl(value)} alt="" className="h-20 w-auto rounded-md border object-cover" />}
          <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-gray-800 text-white flex items-center justify-center" aria-label="Quitar"><X className="w-3 h-3" /></button>
        </div>
      )}
    </div>
  );
}
